import { render, staticRenderFns } from "./SectorsTable.vue?vue&type=template&id=10704994&"
import script from "./SectorsTable.vue?vue&type=script&lang=js&"
export * from "./SectorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports